import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from '../store';
import Layout from '@/components/Layout/Layout.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: { name: "Home" }
  },
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/",
        name: "Home",
        meta: {
          requiresAuth: false,
          title: "Inteli | Inicio"
        },
        /* all params set as prop sample: ?param1=uno&param2=dos..... */
        props(route) {
          return  route.query || {}
        },
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Home.vue")
      },
      {
        path: "/checkout/:k?",
        name: 'CheckOut',
        meta: {
          requiresAuth: false,
          title: "Inteli | Registrar Salida"
        },
        component: () =>
          import("../views/CheckOut.vue")
      },
      {
        path: "on-site",
        name: "OnSite",
        meta: {
          requiresAuth: false,
          title: "Inteli"
        },
        component: () =>
          import("../views/OnSite.vue")
      },
      { path: '*', redirect: '/' }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // to and from are both route objects. must call `next`.
  // set title on fly based on router title
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if(nearestWithTitle){
    document.title = nearestWithTitle.meta.title;
    store.commit('set_title', nearestWithTitle.meta.title)
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      router.push({
        name: 'Login', query: {to: to.name}, params: { id: to.params.id },
      })
    } else {
      next()
    }
  } else {
    next()
  }

});

export default router
